import React, { useEffect, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import cn from 'classnames';
import { Loader } from '@landing/ui';
import { MAP_SETTINGS, MARKER_SETTINGS } from './constants';

import * as styles from './LocationMap.module.scss';

export default function LocationMap({ className }) {
  const [inViewRef, inView] = useInView();
  const mapContainerRef = useRef(null);
  const [mapVisible, setMapVisible] = useState(false);
  const [map, setMap] = useState(null);

  useEffect(() => {
    if (inView && !mapVisible) {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.GATSBY_GOOGLE_MAPS_API_KEY}&callback=initMap&language=en`;
      script.async = true;
      script.type = 'text/javascript';

      document.body.appendChild(script);

      setMapVisible(true);

      return () => document.body.removeChild(script);
    }
  }, [inView, mapVisible]);

  if (typeof window !== 'undefined') {
    window.initMap = () => {
      const map = new window.google.maps.Map(mapContainerRef.current, MAP_SETTINGS);

      const marker = new window.google.maps.Marker({ map: map, ...MARKER_SETTINGS });

      const { title, address, city, country, link } = MARKER_SETTINGS;

      const contentString = `
        <div class="${styles.info}">
          <div class="${styles.infoTitle}">${title}</div>
          <div class="${styles.address}">
            <p>${address}</p>
            <p>${city}</p>
            <p>${country}</p>
          </div>
          <div class="${styles.linkWrapper}">
            <a target="_blank" href="${link}" >
              <span> View on Google Maps </span>
            </a>
          </div>
        </div>
      `;

      const infoWindow = new window.google.maps.InfoWindow({
        content: contentString,
        ariaLabel: 'Andersen office',
      });

      marker.addListener('click', () => {
        infoWindow.open({
          anchor: marker,
          map,
        });
      });

      setMap(map);
    };
  }

  const handleZoom = step => {
    if (map) {
      const currentZoom = map.getZoom();
      map.setZoom(currentZoom + step);
    }
  };

  return (
    <div ref={inViewRef} className={className}>
      {mapVisible ? (
        <div className={styles.mapWrapper}>
          <div ref={mapContainerRef} className={styles.map} />
          <div className={styles.zoomControls}>
            <button
              className={cn(styles.zoomButton, styles.plusButton)}
              onClick={() => handleZoom(1)}
            />
            <button
              className={cn(styles.zoomButton, styles.minusButton)}
              onClick={() => handleZoom(-1)}
            />
          </div>
        </div>
      ) : (
        <Loader theme="block" />
      )}
    </div>
  );
}
